// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostDropdown_DropdownItem__otv\\+M {
    display: inline-block;
    max-width: 50%;
    padding: 0px;
    z-index: 99 !important;
  }

  .PostDropdown_DropdownItem__otv\\+M {
    padding: 0px;
    z-index: 99 !important;
  }

  .PostDropdown_Menu__9OJJ7 {
  position: absolute !important;
  right: 0 !important;
  left: auto !important;
  z-index: 99 !important;
  top: 25px !important;
  transform: translate3d(0px, 0px, 0px) !important;
  background: #fff !important;
  padding-top: 0px;
  /* padding-bottom: 3px; */
  font-size: .75rem;
  border: 0;
  margin: 0;
  height: auto !important;
  width: 60px !important;
  /* inset: 5px auto auto -145px !important; */

}
  
  .PostDropdown_Absolute__ZCy65 {
    position: absolute;
    right: 0; 
    top: 200; 
    z-index: 99 !important;
  }

  .PostDropdown_Rel__OLAg7 {
    position: relative;
  }

  .PostDropdown_DropdownItem__otv\\+M i {
    color: #666 !important;
  }`, "",{"version":3,"sources":["webpack://./src/styles/PostDropdown.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;EACA,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,gDAAgD;EAChD,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;;AAE9C;;EAEE;IACE,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB","sourcesContent":[".DropdownItem {\n    display: inline-block;\n    max-width: 50%;\n    padding: 0px;\n    z-index: 99 !important;\n  }\n\n  .DropdownItem {\n    padding: 0px;\n    z-index: 99 !important;\n  }\n\n  .Menu {\n  position: absolute !important;\n  right: 0 !important;\n  left: auto !important;\n  z-index: 99 !important;\n  top: 25px !important;\n  transform: translate3d(0px, 0px, 0px) !important;\n  background: #fff !important;\n  padding-top: 0px;\n  /* padding-bottom: 3px; */\n  font-size: .75rem;\n  border: 0;\n  margin: 0;\n  height: auto !important;\n  width: 60px !important;\n  /* inset: 5px auto auto -145px !important; */\n\n}\n  \n  .Absolute {\n    position: absolute;\n    right: 0; \n    top: 200; \n    z-index: 99 !important;\n  }\n\n  .Rel {\n    position: relative;\n  }\n\n  .DropdownItem i {\n    color: #666 !important;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"DropdownItem": `PostDropdown_DropdownItem__otv+M`,
	"Menu": `PostDropdown_Menu__9OJJ7`,
	"Absolute": `PostDropdown_Absolute__ZCy65`,
	"Rel": `PostDropdown_Rel__OLAg7`
};
export default ___CSS_LOADER_EXPORT___;
